import { AttendanceState, useEventFormFunctionalWrapperGuestAttendanceStateQuery } from '@graphql/generated';
import { EventFormContactData } from '../../../presentational/hooks/useEventFormState';

export const useAttendanceState = (eventId: string, guestKey: string) => {
  const { data, loading, error } = useEventFormFunctionalWrapperGuestAttendanceStateQuery({
    variables: {
      eventId,
      guestKey,
    },
    skip: !guestKey,
    batchMode: 'fast',
  });

  const attendanceRaw = data?.guestAttendanceByEventId?.attendanceState;
  const attendanceState = attendanceRaw !== null ? attendanceRaw === AttendanceState.ATTENDING : null;
  const contactRaw = data?.guestAttendanceByEventId?.contact ?? undefined;

  let contact: EventFormContactData | undefined = undefined;

  if (contactRaw?.firstName && contactRaw?.lastName && contactRaw?.email) {
    contact = {
      firstName: contactRaw.firstName,
      lastName: contactRaw.lastName,
      email: contactRaw.email,
    };
  }

  return { attendanceState, loading, error, contact };
};
